import {InjectionToken} from '@angular/core';
import {Locale} from '@aztrix/models';
import {BehaviorSubject} from 'rxjs';

export const LOCALE = new InjectionToken<BehaviorSubject<Locale>>('LOCALE');
